import React from 'react';

const BlogArticulo = ({ articulo }) => {
  // Simulación de un artículo ficticio si no se proporcionan datos
  const articuloDatos = articulo || {
    titulo: 'Descubre las maravillas del Universo',
    contenido: `
      El universo es un lugar vasto y misterioso, lleno de sorpresas en cada rincón. Desde las estrellas más antiguas hasta los agujeros negros que desafían la comprensión humana, el espacio exterior sigue siendo un terreno de exploración fascinante para científicos y aficionados por igual.

      En este artículo, exploraremos algunos de los aspectos más fascinantes del cosmos, desde la teoría del Big Bang hasta los últimos descubrimientos realizados por los telescopios espaciales más avanzados.
      
      Si alguna vez has mirado al cielo nocturno y te has preguntado qué hay más allá, este es el lugar para comenzar tu aventura cósmica. Con cada descubrimiento, nos acercamos un poco más a entender el origen del universo y nuestro lugar en él.
    `,
    autor: 'Juan Pérez',
    fecha: '25 de Septiembre, 2024',
    imagen: 'https://via.placeholder.com/1200x600?text=Imagen+del+Universo',
  };

  return (
    <main className="container mt-5">
      <article className="blog-post shadow-sm rounded overflow-hidden">
        {/* Imagen destacada */}
        <div className="blog-post-image">
          <img
            src={articuloDatos.imagen}
            alt={`Imagen destacada de ${articuloDatos.titulo}`}
            className="img-fluid w-100"
            style={{ maxHeight: '500px', objectFit: 'cover' }}
          />
        </div>

        {/* Encabezado del artículo */}
        <div className="blog-post-header p-4">
          <h1 className="display-4">{articuloDatos.titulo}</h1>
          <p className="text-muted">
            Por <strong>{articuloDatos.autor}</strong> • {articuloDatos.fecha}
          </p>
        </div>

        {/* Contenido del artículo */}
        <div className="blog-post-content p-4">
          <p className="lead">{articuloDatos.contenido}</p>

          {/* Aquí podrías agregar secciones adicionales */}
          <section className="my-4">
            <h3 className="mb-3">Exploración espacial: El futuro de la humanidad</h3>
            <p>
              Desde que el ser humano puso un pie en la Luna, el deseo de explorar más allá de nuestro planeta no ha cesado. Misiones espaciales como la exploración de Marte y la búsqueda de exoplanetas habitables nos muestran que el futuro de la humanidad podría estar en las estrellas.
            </p>
            <blockquote className="blockquote p-3 my-4 border-start border-info">
              "La Tierra es la cuna de la humanidad, pero no podemos quedarnos en la cuna para siempre" — Konstantin Tsiolkovsky.
            </blockquote>
          </section>

          <section className="my-4">
            <h3 className="mb-3">Los misterios de los agujeros negros</h3>
            <p>
              Los agujeros negros son objetos cósmicos con una atracción gravitacional tan intensa que ni siquiera la luz puede escapar. Recientes avances tecnológicos han permitido que los científicos obtengan las primeras imágenes de un agujero negro, un avance monumental en nuestra comprensión del universo.
            </p>
          </section>
        </div>

        {/* Sección de comentarios */}
        <div className="blog-post-comments p-4 border-top mt-4">
          <h5 className="mb-3">Comentarios</h5>
          <ul className="list-unstyled">
            <li className="mb-3">
              <strong>Lucía Gómez</strong> <small className="text-muted">— Hace 2 horas</small>
              <p>
                ¡Excelente artículo! Me fascina todo lo relacionado con el espacio y este post realmente me inspiró a aprender más sobre los agujeros negros.
              </p>
            </li>
            <li className="mb-3">
              <strong>Carlos Méndez</strong> <small className="text-muted">— Hace 1 día</small>
              <p>
                Siempre me he preguntado si realmente lograremos colonizar Marte algún día. ¿Cuál es tu opinión al respecto?
              </p>
            </li>
          </ul>

          {/* Formulario para agregar un comentario */}
          <form>
            <div className="form-group mb-3">
              <textarea className="form-control" placeholder="Escribe un comentario..." rows="3"></textarea>
            </div>
            <button type="submit" className="btn btn-primary">Publicar comentario</button>
          </form>
        </div>
      </article>
    </main>
  );
};

export default BlogArticulo;
